export default Object.freeze({
  CHROME: 'chrome',
  FIREFOX: 'firefox'
})
